import { companiesUrl, wpNonce } from './constants/general';

export const getCompanies = async () => {
  try {
    const response = await fetch(companiesUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-WP-Nonce': wpNonce,
      },
    });

    if (response.ok) {
      const result = await response.json();
      return result;
    }

    return [];
    // throw new Error(response.statusText)
  } catch (err) {
    return Promise.reject(err.message ? err.message : result);
  }
};
